module.exports = __webpack_public_path__ + "media/images/countryrect/sh-a21b5ee617f1eb8b15d7759422aebf27.svg";